import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * <ScrollToTop /> — mount once inside <BrowserRouter>.
 *
 * Scrolls to the very top of the page on every route change.
 *
 * Skipped when the URL contains a hash anchor (e.g. /workshop#reserve) —
 * in that case React handles the in-page scroll via the anchor target.
 *
 * Uses `instant` behavior so users never see a "scroll back up" animation
 * — feels like a normal multi-page site.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // honor in-page anchors
    if (typeof window === "undefined") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
